import { HttpClient, httpResource } from '@angular/common/http'
import { computed, inject, Injectable } from '@angular/core'
import { env } from '../../../environments/environment'
import { VertragsMeldungIntern, VertragsMeldungStatusAenderung } from '../model/intern-backend.model'

/**
 * Arbeitsliste der Vertragsmeldungen aus dem Sanitätshaus-Portal. Erledigen kann den Beitritt gleich
 * am Vertrag eintragen, mit derselben Kollisionsprüfung wie „Verträge zuweisen"
 * (Backend-Repo: `docs/claude/vertragsbeitritte.md`).
 */
@Injectable({ providedIn: 'root' })
export class VertragsmeldungenService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = env().api.internalUrl

  /**
   * Alle Meldungen, eine Quelle für Seite und Zähler in der Navigation. Die Seite lädt sie beim
   * Betreten und nach jeder Statusänderung neu (angular.md: geteilte Resource selbst neu laden).
   */
  readonly alle = httpResource<VertragsMeldungIntern[]>(() => `${this.apiUrl}/vertragsmeldungen`)

  /** Unberührte Meldungen: das, worauf noch niemand bei SaniUp reagiert hat. Zahl am Menüpunkt. */
  readonly neu = computed(() => (this.alle.hasValue() ? this.alle.value().filter((m) => m.status === 'EINGEGANGEN').length : 0))

  statusSetzen$(meldung: Pick<VertragsMeldungIntern, 'id' | 'sanitaetshausId'>, aenderung: VertragsMeldungStatusAenderung) {
    return this.http.put<VertragsMeldungIntern>(
      `${this.apiUrl}/vertragsmeldungen/sanitaetshaus/${meldung.sanitaetshausId}/${meldung.id}/status`,
      aenderung,
    )
  }

  datei$(meldung: Pick<VertragsMeldungIntern, 'id' | 'sanitaetshausId'>, dateiId: string) {
    return this.http.get(`${this.apiUrl}/vertragsmeldungen/sanitaetshaus/${meldung.sanitaetshausId}/${meldung.id}/dateien/${dateiId}`, {
      responseType: 'blob',
    })
  }
}
